/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebFilterFileSlot = typeof WebFilterFileSlot[keyof typeof WebFilterFileSlot];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebFilterFileSlot = {
  Icon: 'Icon',
  Banner: 'Banner',
  HomePage: 'HomePage',
} as const;
